import React from 'react';
import Shimmer from './Shimmer';

const MunicipalCouncilShimmer = () => {
    const documents = Array(4).fill(null);

    return (
        <section className="py-16 bg-gradient-to-br from-gray-50 to-white">
            <div className="max-w-6xl mx-auto px-4">
                {/* Header Shimmer */}
                <div className="text-center mb-12">
                    <Shimmer className="h-10 w-64 mx-auto rounded-lg mb-4"/>
                    <Shimmer className="h-5 w-96 mx-auto rounded"/>
                </div>

                {/* Search and Filter Section Shimmer */}
                <div className="mb-8 space-y-4 md:space-y-0 md:flex md:items-center md:justify-between">
                    {/* Search Input Shimmer */}
                    <div className="relative">
                        <div className="absolute left-3 top-1/2 -translate-y-1/2">
                            <Shimmer className="w-5 h-5 rounded-full"/>
                        </div>
                        <Shimmer className="w-full md:w-80 h-10 rounded-lg"/>
                    </div>

                    {/* Filter Select Shimmer */}
                    <div className="flex items-center gap-2">
                        <Shimmer className="w-5 h-5 rounded-full"/>
                        <Shimmer className="w-48 h-10 rounded-lg"/>
                    </div>
                </div>

                {/* Documents Grid Shimmer */}
                <div className="grid gap-6">
                    {documents.map((_, index) => (
                        <div
                            key={index}
                            className="bg-white rounded-xl p-6 shadow-sm border border-gray-100"
                        >
                            <div className="flex flex-col md:flex-row md:items-center gap-6">
                                {/* Icon Shimmer */}
                                <div className="flex-shrink-0">
                                    <Shimmer className="w-12 h-12 rounded-lg"/>
                                </div>

                                {/* Content Shimmer */}
                                <div className="flex-grow space-y-3">
                                    <Shimmer className="h-6 w-3/4 rounded"/>
                                    <Shimmer className="h-4 w-full rounded"/>
                                    <div className="flex flex-wrap gap-4">
                                        <div className="flex items-center gap-2">
                                            <Shimmer className="w-4 h-4 rounded"/>
                                            <Shimmer className="h-4 w-24 rounded"/>
                                        </div>
                                        <div className="flex items-center gap-2">
                                            <Shimmer className="w-4 h-4 rounded"/>
                                            <Shimmer className="h-4 w-24 rounded"/>
                                        </div>
                                    </div>
                                </div>

                                {/* Download Button Shimmer */}
                                <div className="flex-shrink-0">
                                    <Shimmer className="w-36 h-10 rounded-lg"/>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default MunicipalCouncilShimmer;